import React from "react";
import { Link } from "react-router-dom";
import { Layout, Typography, Row, Col, Divider } from "antd";
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from "@ant-design/icons";

const { Footer: AntFooter } = Layout;
const { Title, Paragraph } = Typography;

const COLORS = {
  accent: "#c9b37e",
  accentDark: "#b3a068",
};

function Footer() {
  const screens = { md: true }; // You can use useBreakpoint() here if needed

  return (
    <AntFooter
      style={{
        background: COLORS.accent,
        padding: screens.md ? "80px 60px 40px" : "60px 20px 30px",
        color: "#000",
      }}
    >
      <div id="contact" />

      {/* TOP BRAND */}
      <div style={{ textAlign: "center", marginBottom: 60 }}>
        <Link to="/">
          <img
            src="/logo_jpg.png"
            alt="logo"
            style={{ height: 70, marginBottom: 20, cursor: "pointer" }}
          />
        </Link>
        <Title level={4} style={{ marginBottom: 8, color: "#000" }}>
          JP Hollandwoven Private Limited
        </Title>
        <Paragraph style={{ maxWidth: 700, margin: "0 auto", color: "#000" }}>
         Khata No. 225, Khasra No. 74, Village - Talabpur Urf Hathipur, Paragna and Tehsil Dadri, Gautam Budh Nagar, UP (201301)
        </Paragraph>
      </div>

      <Divider style={{ borderColor: "rgba(0,0,0,0.2)" }} />

      <Row gutter={[48, 48]} align="top">
        {/* COLUMN 1: HOME SECTIONS */}
        <Col xs={24} sm={12} md={6}>
          <Title level={5} style={{ color: "#000" }}>Explore</Title>
          {/* Using <a> tags for reliable cross-page hash scrolling */}
          <Paragraph><a href="/#products" className="footer-link">Our Products</a></Paragraph>
          <Paragraph><a href="/#gallery" className="footer-link">Photo Gallery</a></Paragraph>
          <Paragraph><a href="/#reviews" className="footer-link">Testimonials</a></Paragraph>
          <Paragraph><a href="/#connect" className="footer-link">Quick Inquiry</a></Paragraph>
        </Col>

        {/* COLUMN 2: COMPANY PAGE LINKS */}
        <Col xs={24} sm={12} md={6}>
          <Title level={5} style={{ color: "#000" }}>Company</Title>
          {/* Links to OurCompany.jsx sections */}
          <Paragraph><Link to="/our-company#about-us" className="footer-link">About Us</Link></Paragraph>
          <Paragraph><Link to="/our-company#team" className="footer-link">Our Team</Link></Paragraph>
          <Paragraph><Link to="/our-company#certificates" className="footer-link">Certificates</Link></Paragraph>
          <Paragraph><Link to="/our-company#contact-us-section" className="footer-link">Contact Details</Link></Paragraph>
        </Col>

        {/* COLUMN 3: DIRECT CONTACT */}
        <Col xs={24} sm={12} md={6}>
          <Title level={5} style={{ color: "#000" }}>Contact</Title>
          <Paragraph>
            <a href="tel:+919560322811" className="footer-link">
              <PhoneOutlined style={{ marginRight: 8 }} /> +91-9560322811
            </a>
          </Paragraph>
          <Paragraph>
            <a href="tel:+919650257414" className="footer-link">
              <PhoneOutlined style={{ marginRight: 8 }} /> +91-9650257414
            </a>
          </Paragraph>
          <Paragraph>
            <a href="tel:+919760211000" className="footer-link">
              <PhoneOutlined style={{ marginRight: 8 }} /> +91-9760211000
            </a>
          </Paragraph>
          <Paragraph>
            <a href="mailto:contactus@jphollandwoven.com" className="footer-link">
              <MailOutlined style={{ marginRight: 8 }} /> contactus@jphollandwoven.com
            </a>
          </Paragraph>
        </Col>

        {/* COLUMN 4: LOCATION MAP */}
        <Col xs={24} md={6}>
          <Title level={5} style={{ color: "#000" }}>Location</Title>
          <div style={{ borderRadius: 14, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.15)", border: "1px solid rgba(0,0,0,0.2)" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14009.347714466676!2d77.48714185245521!3d28.61966241074464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cedb96aaaaaab%3A0x7f914b31a7af81!2sJP%20HOLLANDWOVEN%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1770622831347!5m2!1sen!2sin"
              width="100%" 
              height="200" 
              style={{ border: 0, display: "block" }} 
              loading="lazy"
              title="Footer Map"
            />
          </div>
        </Col>
      </Row>

      <Divider style={{ margin: "60px 0 30px", borderColor: "rgba(0,0,0,0.2)" }} />

      <Paragraph style={{ textAlign: "center", margin: 0, fontWeight: 500, color: "#000" }}>
        © {new Date().getFullYear()} JP Hollandwoven Private Limited. All Rights Reserved.
      </Paragraph>

      <style>{`
        .footer-link {
          color: #000 !important;
          text-decoration: none;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-block;
        }
        .footer-link:hover {
          opacity: 0.7;
          transform: translateX(5px);
        }
      `}</style>
    </AntFooter>
  );
}

export default Footer;